import React, { useState } from 'react';
import "./VerifyAccount.css";
import img from "../../assets/Frame 18140610.png";
// import { useNavigate } from 'react-router-dom';
import { countryCodeList } from '../../data.js';
import axios from "axios";

import { baseUrl } from '../../common/baseUrl.js';
import PageLoader from '../components/PageLoader/PageLoader.jsx';
import axiosInstance from '../../axiosInstance/axiosInstance';
import Dropdown from "../components/Dropdown/Dropdown";

export default function VerifyAccount({onNextStep}) 
{
    const [inputs, setInputs] = useState({ countrycode: "+91", contact: "" });
    const [errors, setErrors] = useState({ contact: "" });
    const [isFormValid, setIsFormValid] = useState(true);
    const [isLoading,setIsLoading] = useState(false);


    // const navigate = useNavigate();
    // Validations in phone 
    
    const validatePhone = (contact, maxLength) => {
        const errors = { contact: "" };
        if (!contact) {
            errors.contact = "Please enter your phone number";
        } else if (contact.length !== maxLength) {
            errors.contact = `Phone number must be ${maxLength} digits long`;
        } else if (!/^\d+$/.test(contact)) {
            errors.contact = "Please enter a valid phone number";
        }
        return errors;
    };

    // Handle Change Function
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInputs(prevInputs => ({ ...prevInputs, [name]: value }));

        // Validate phone number
        if (name === 'contact') {
            const selectedCountry = countryCodeList.find(country => country.code === inputs.countrycode);
            const maxLength = selectedCountry ? selectedCountry.length : 10;

            const validationErrors = validatePhone(value, maxLength);
            setErrors(validationErrors);
            setIsFormValid(Object.values(validationErrors).every(error => error === ""));
        }
    };

    // Form Submission Function
    const handleSubmit = async (event) => {

        try{

            event.preventDefault();
            setIsLoading(true);
        
            // Perform final validation before submitting
            const selectedCountry = countryCodeList.find(country => country.code === inputs.countrycode);
            const maxLength = selectedCountry ? selectedCountry.length : 10;
            
            const validationErrors = validatePhone(inputs.contact, maxLength);
            setErrors(validationErrors);
            
            if (Object.values(validationErrors).every(error => error === "")) {

                // Sending Request for OTP
                try {
                    // Concatenate country code and contact and convert to integer
                    const fullContact = parseInt(`${inputs.countrycode.slice(1)}${inputs.contact}`, 10);

                    const requestData = {
                        contact: fullContact // Use the integer contact format
                    };
                    // console.log("Contact (Integer): " + fullContact);
                    
                    const response = await axiosInstance.post(`/api/v1/user/request-otp`, requestData);
                    // console.log("Response: " + response.data);
                    
                    onNextStep(fullContact);

                    // navigate("/createProfile", { state: { contact: fullContact } });
        
                } catch (error) {
                    console.error(error);
                }
            } else {
                setIsFormValid(false);
            }

        }catch(error){
            console.log(error)
        }
        finally{
            setIsLoading(false);
        }

    };
    

    const selectedCountry = countryCodeList.find(country => country.code === inputs.countrycode);
    const maxLength = selectedCountry ? selectedCountry.length : 10;

    const isButtonEnabled = inputs.contact.length === maxLength && isFormValid;

    return (
        <>
            {isLoading && <PageLoader/>}
            <form id="verifyForm" onSubmit={handleSubmit}>
                <div className="verify-profile-main">
                    <div className="verify1">
                        <div className="verify1-img">
                            <img src={img} alt="Verify" />
                        </div>
                        <div className="verify1-account">
                            <div className="verify1-header">
                                <h3>Verify Account</h3>
                            </div>
                            <div className="verify1-inp">
                                <label htmlFor="contact">Contact</label>
                                <div className="verify1-inputs">
                                    <Dropdown
                                        name="countrycode"
                                        value={inputs.countrycode}
                                        onChange={handleChange}
                                        placeholder="Code"
                                        searchPlaceholder="Search country"
                                        options={countryCodeList.map(country => ({
                                            value: country.code,
                                            label: `${country.name} (${country.code})`,
                                            fieldLabel: country.code,
                                        }))}
                                    />
                                    <input
                                        type="text"
                                        name="contact"
                                        id="contact"
                                        inputMode="numeric"
                                        onChange={handleChange}
                                        value={inputs.contact || ""}
                                        placeholder="Enter Contact Number"
                                        autoComplete="off"
                                        maxLength={maxLength}
                                    />
                                </div>
                                {/* Error message displayed right after the input container */}
                                {errors.contact && <div className="error-message">{errors.contact}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="verify2-btn">
                        <button type="submit" disabled={!isButtonEnabled}>
                            Send OTP
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
